import React from 'react';
import { withRouter, Link } from 'react-router-dom'; 
import { Row, Col, Image } from 'react-bootstrap';
// src
import * as routes from '../../routes/routes_production.js';
import logo from '../../img/logo2.png';
import '../styles/commonStyles.css';
import './navigationBarStyles.css';

const NavigationBar = ({ history, location }) => (
  <Row className="show-grid">
    <Col xs={12}>     
      <ul className="navigationBar"> 
        <li className="logo">
          <Image src={logo} width="75%"/>
        </li>                        
        
        <li className={
          (location.pathname===routes.NEW_ORDER)||(location.pathname===routes.EDIT_ORDER)? 
            "activeNavItem": ""} onClick={() => (history.push(routes.NEW_ORDER) )} >
          <Link to={routes.NEW_ORDER}>Nuovo ordine</Link>
        </li>

        <li className={(location.pathname===routes.ORDERS_SUMMARY)? "activeNavItem": ""}
            onClick={() => (history.push(routes.ORDERS_SUMMARY) )}>
          <Link to={routes.ORDERS_SUMMARY}>Riepilogo ordini</Link>
        </li>

        <li onClick={() => {
              localStorage.removeItem('serialeOperatore');  
              history.push(routes.LANDING); 
            }
        }>        
          <span className="colorRed">Logout</span>
        </li>
      </ul>  
    </Col>  
  </Row> 
);

export default withRouter(NavigationBar);


// WEBPACK FOOTER //
// ./src/cmp/NavigationBar/NavigationBar.js